import { DatePickerButtonType } from './types';

export const CALENDAR = { GREGORIAN: 'G', FISCAL: 'F' } as const;
export const DATE_TYPE = {
  DATE_ONLY: 'DATE_ONLY',
  DATE_TIME: 'DATE_TIME',
} as const;
export const RANGE = {
  DAY: 'DY',
  WEEK: 'WK',
  MONTH: 'MO',
  QUARTER: 'QR',
  YEAR: 'YR',
  CUSTOM: 'C',
  DAYS: 'D',
  WEEKS: 'W',
  MONTHS: 'M',
  QUARTERS: 'Q',
  YEARS: 'Y',
} as const;
export const PERIOD = {
  DEFINED: 'D',
  PRIOR: 'P',
  CURRENT: 'C',
  NEXT: 'N',
  YEAR: 'Y',
} as const;

export type DATE_PICKER_BUTTON_ID =
  | 'custom'
  | 'yesterday'
  | 'weekToDate'
  | 'monthToDate'
  | 'quarterToDate'
  | 'yearToDate'
  | 'lastWeek'
  | 'lastMonth'
  | 'lastQuarter'
  | 'lastYear'
  | 'last7Days'
  | 'last30Days'
  | 'last12Months';

export const DATE_PICKER_BUTTON = {
  Custom: 'custom',
  Yesterday: 'yesterday',
  WeekToDate: 'weekToDate',
  MonthToDate: 'monthToDate',
  QuarterToDate: 'quarterToDate',
  YearToDate: 'yearToDate',
  LastWeek: 'lastWeek',
  LastMonth: 'lastMonth',
  LastQuarter: 'lastQuarter',
  LastYear: 'lastYear',
  Last7Days: 'last7Days',
  Last30Days: 'last30Days',
  Last12Months: 'last12Months',
} as const;

export const datePickerButtons: DatePickerButtonType[] = [
  {
    id: DATE_PICKER_BUTTON.Custom,
    label: 'datePicker.presetMenu.customRange',
    start_date: null,
    end_date: null,
    rangeType: RANGE.CUSTOM,
    selected: 0,
  },
  {
    id: DATE_PICKER_BUTTON.Yesterday,
    label: 'datePicker.presetMenu.yesterday',
    rangeType: RANGE.DAYS,
    number: 0,
    break: true,
    selected: 1,
  },
  {
    id: DATE_PICKER_BUTTON.WeekToDate,
    label: 'datePicker.presetMenu.weekToDate',
    rangeType: RANGE.WEEKS,
    number: 0,
    selected: 2,
  },
  {
    id: DATE_PICKER_BUTTON.MonthToDate,
    label: 'datePicker.presetMenu.monthToDate',
    rangeType: RANGE.MONTHS,
    number: 0,
    selected: 3,
  },
  {
    id: DATE_PICKER_BUTTON.QuarterToDate,
    label: 'datePicker.presetMenu.quarterToDate',
    rangeType: RANGE.QUARTERS,
    number: 0,
    selected: 4,
  },
  {
    id: DATE_PICKER_BUTTON.YearToDate,
    label: 'datePicker.presetMenu.yearToDate',
    rangeType: RANGE.YEARS,
    number: 0,
    selected: 5,
  },
  {
    id: DATE_PICKER_BUTTON.LastWeek,
    label: 'datePicker.presetMenu.lastWeek',
    rangeType: RANGE.WEEKS,
    number: 1,
    break: true,
    selected: 6,
  },
  {
    id: DATE_PICKER_BUTTON.LastMonth,
    label: 'datePicker.presetMenu.lastMonth',
    rangeType: RANGE.MONTHS,
    number: 1,
    selected: 7,
  },
  {
    id: DATE_PICKER_BUTTON.LastQuarter,
    label: 'datePicker.presetMenu.lastQuarter',
    rangeType: RANGE.QUARTERS,
    number: 1,
    selected: 8,
  },
  {
    id: DATE_PICKER_BUTTON.LastYear,
    label: 'datePicker.presetMenu.lastYear',
    rangeType: RANGE.YEARS,
    number: 1,
    selected: 9,
  },
  {
    id: DATE_PICKER_BUTTON.Last7Days,
    label: 'datePicker.presetMenu.last7Days',
    number: 7,
    rangeType: RANGE.DAYS,
    break: true,
    selected: 10,
  },
  {
    id: DATE_PICKER_BUTTON.Last30Days,
    label: 'datePicker.presetMenu.last30Days',
    number: 30,
    rangeType: RANGE.DAYS,
    selected: 11,
  },
  {
    id: DATE_PICKER_BUTTON.Last12Months,
    label: 'datePicker.presetMenu.last12Months',
    number: 12,
    rangeType: RANGE.MONTHS,
    selected: 12,
  },
];
